{
	"title": "Review today",
	"subtitle": "Adaptive recommendations",
	"refresh": "Refresh",
	"preliminary": "Refining…",
	"updatedAt": "Updated {time}",
	"staleHint": "Updated {hours, plural, one {# hour} other {# hours}} ago",
	"showMore": "Show more",
	"showAll": "All recommendations",
	"empty": {
		"title": "All clear — nothing urgent",
		"body": "Check back tomorrow or explore a new topic",
		"newTopic": "New topic",
		"templates": "Study plan templates"
	},
	"action": {
		"study": "Study",
		"take": "Take",
		"continue": "Continue",
		"open": "Open",
		"studyNow": "Study now",
		"dismiss": "Dismiss"
	},
	"reason": {
		"srs-due": "Urgent — due for review",
		"weak-spot": "Weak spot",
		"new-material": "New material",
		"streak-at-risk": "Streak at risk",
		"study-plan-next": "Next plan topic",
		"forgotten-topic": "Forgotten topic",
		"exam-soon": "Exam soon"
	},
	"priority": "Priority",
	"error": {
		"title": "Failed to load recommendations",
		"retry": "Retry"
	}
}
